import script from "./batchGoodsGiftRemoveRecover.vue?vue&type=script&setup=true&lang=js"
export * from "./batchGoodsGiftRemoveRecover.vue?vue&type=script&setup=true&lang=js"

import "./batchGoodsGiftRemoveRecover.vue?vue&type=style&index=0&id=67f0c2f9&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f0c2f9"]])

export default __exports__